var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _SafeSet_instances, _a, _SafeSet_isPrimitive, _SafeSet_serialise, _SafeSet_deserialise, _SafeSet_set, _SafeSet_newSet;
import { defaultDeserialiser, defaultSerialiser, } from "../domain";
export class SafeSet {
    constructor(serialiser, deserialiser, set) {
        _SafeSet_instances.add(this);
        _SafeSet_isPrimitive.set(this, void 0);
        _SafeSet_serialise.set(this, void 0);
        _SafeSet_deserialise.set(this, void 0);
        _SafeSet_set.set(this, void 0);
        __classPrivateFieldSet(this, _SafeSet_isPrimitive, serialiser === undefined && deserialiser === undefined, "f");
        __classPrivateFieldSet(this, _SafeSet_serialise, serialiser ?? defaultSerialiser, "f");
        __classPrivateFieldSet(this, _SafeSet_deserialise, deserialiser ?? defaultDeserialiser, "f");
        __classPrivateFieldSet(this, _SafeSet_set, set ?? new Set(), "f");
    }
    clone() {
        const clone = __classPrivateFieldGet(this, _SafeSet_instances, "m", _SafeSet_newSet).call(this);
        for (const val of this) {
            clone.add(val);
        }
        return clone;
    }
    forEach(callbackfn) {
        for (const value of this) {
            callbackfn(value, value, this);
        }
    }
    entries() {
        const set = __classPrivateFieldGet(this, _SafeSet_set, "f");
        const deserialise = (s) => __classPrivateFieldGet(this, _SafeSet_deserialise, "f").call(this, s);
        const it = set.entries();
        return {
            [Symbol.iterator]() {
                return this;
            },
            next() {
                const result = it.next();
                if (result.done)
                    return { done: true, value: undefined };
                const [serialisedVal] = result.value;
                const originalVal = deserialise(serialisedVal);
                return { done: false, value: [originalVal, originalVal] };
            },
        };
    }
    values() {
        return this.keys();
    }
    keys() {
        const set = __classPrivateFieldGet(this, _SafeSet_set, "f");
        const deserialise = (s) => __classPrivateFieldGet(this, _SafeSet_deserialise, "f").call(this, s);
        const it = set.entries();
        return {
            [Symbol.iterator]() {
                return this;
            },
            next() {
                const result = it.next();
                if (result.done)
                    return { done: true, value: undefined };
                const [serialisedVal] = result.value;
                const originalVal = deserialise(serialisedVal);
                return { done: false, value: originalVal };
            },
        };
    }
    [(_SafeSet_isPrimitive = new WeakMap(), _SafeSet_serialise = new WeakMap(), _SafeSet_deserialise = new WeakMap(), _SafeSet_set = new WeakMap(), _SafeSet_instances = new WeakSet(), _SafeSet_newSet = function _SafeSet_newSet() {
        return __classPrivateFieldGet(this, _SafeSet_isPrimitive, "f")
            ? new _a(undefined, undefined)
            : new _a(__classPrivateFieldGet(this, _SafeSet_serialise, "f"), __classPrivateFieldGet(this, _SafeSet_deserialise, "f"));
    }, Symbol.iterator)]() {
        return this.values();
    }
    empty() {
        return __classPrivateFieldGet(this, _SafeSet_instances, "m", _SafeSet_newSet).call(this);
    }
    clear() {
        __classPrivateFieldGet(this, _SafeSet_set, "f").clear();
    }
    delete(value) {
        const svalue = __classPrivateFieldGet(this, _SafeSet_serialise, "f").call(this, value);
        return __classPrivateFieldGet(this, _SafeSet_set, "f").delete(svalue);
    }
    has(value) {
        return __classPrivateFieldGet(this, _SafeSet_set, "f").has(__classPrivateFieldGet(this, _SafeSet_serialise, "f").call(this, value));
    }
    add(value) {
        const svalue = __classPrivateFieldGet(this, _SafeSet_serialise, "f").call(this, value);
        __classPrivateFieldGet(this, _SafeSet_set, "f").add(svalue);
        return this;
    }
    get size() {
        return __classPrivateFieldGet(this, _SafeSet_set, "f").size;
    }
    toSet() {
        return __classPrivateFieldGet(this, _SafeSet_set, "f");
    }
    static fromList(values) {
        const set = new _a();
        values.forEach((value) => set.add(value));
        return set;
    }
}
_a = SafeSet;
export class ChatSet extends SafeSet {
    constructor(values) {
        super((k) => JSON.stringify(k), (k) => JSON.parse(String(k)));
        values?.forEach((v) => this.add(v));
    }
}
